import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const TITLES = {
  "/": "Advanced Risk Management Solutions — Changing attitudes, behaviour and culture",
  "/about": "About Us — Advanced Risk Management Solutions",
  "/services": "Our Services — Advanced Risk Management Solutions",
  "/approach": "Our Approach — Advanced Risk Management Solutions",
  "/case-studies": "Case Studies & Testimonials — Advanced Risk Management Solutions",
  "/insights": "Insights & Articles — Advanced Risk Management Solutions",
  "/contact": "Contact Us — Advanced Risk Management Solutions",
  "/admin/login": "Admin Login — ARMS",
  "/admin": "Admin Dashboard — ARMS",
};

export default function RouteMeta() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) window.scrollTo(0, 0);
    const base = "/" + (pathname.split("/")[1] || "");
    document.title = TITLES[pathname] || TITLES[base] || TITLES["/"];
  }, [pathname, hash]);
  return null;
}
